<div class="msg-page app-content">
  <div class="container">
    <div class="row">
      <div class="col-md-2 stick-there">
        <!-- <div class="hpanel p-2">
          <div class="panel-body border-radius-top-left-right-6 pad li" (click)="notificationSettings = false"
          [ngClass]="{ 'active-tab': !notificationSettings }">
            Notifications<span class="badge noti-badge" *ngIf="notificationcount > 0"
              >{{notificationcount}} </span>
            <span *ngIf="notificationcount > 0"> (New)</span>
          </div>
        </div> -->
        <div class="hpanel p-0 ntf-sidebar-panel-3928">
          <div class="panel-body b-r-6" style="padding: 0px;">
            <ul class="custom-panel pad" style="margin-bottom : 0px;">
              <li class="navmenu" (click)="notificationSettings = false"
                  [ngClass]="{'active': !notificationSettings}">
                <!-- <ng-icon name="tablerBell" class="svg-position"></ng-icon> -->

                <a class="letter-spacing-0 navIteam">
                   Notifications<span class="badge noti-badge ntf-count-badge-8523" *ngIf="notificationcount > 0"
                    >{{notificationcount}} </span>
                  <span *ngIf="notificationcount > 0"> (New)</span>
                </a>
              </li>
              <li class="navmenu navIteam" (click)="notificationSettings = true"
                  [ngClass]="{'active': notificationSettings}" *ngIf="userType == 'JOB_SEEKER'">
                <!-- <ng-icon name="tablerSettings" class="svg-position"></ng-icon> -->
                <a class="letter-spacing-0">
                   Notifications Settings
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div *ngIf="!notificationSettings" class="col-md-7">
        <app-common-skeleton
          *ngIf="(isEnabled && commonVariables?.notifications?.length == 0)"
          [countforView]="10" [NameOftheScreen]="'notification'"></app-common-skeleton>

        <div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()">
          <div class="wert1 ntf-loading-state-6271" *ngIf="!responseReceived">
            <div class="col-md-12 mg-bt-9">
              <!-- <img style=" max-height: 9rem;" src="assets/icon/nothing_found.png" alt=""> -->
               <ng-icon name="tablerBell" class="fetching-bell-icon"></ng-icon>
            </div>
            <div class="col-md-12 fig ntf-empty-title-7162"> Fetching Notifications... </div>
          </div>
          <div class="wert ntf-empty-state-4829"
            *ngIf="responseReceived && (commonVariables.notifications == undefined || commonVariables.notifications.length == 0)">
            <div class="col-md-12 mg-bt-9">
              <ng-icon name="tablerBellOff"></ng-icon>
            </div>
            <div class="col-md-12">
              <p class="font-16 ntf-empty-title-7162">You have got no notifications</p>
            </div>
            <div class="col-md-12">
              <p class="biase ntf-empty-desc-3945">Please, check this page when you have one</p>
            </div>
          </div>
          <ng-container *ngFor="let item of commonVariables.notifications; let i=index; let lastItem=last;">
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate:22 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read || isSuperAdmin">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item *ngIf="isSuperAdmin" (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PROMOTIONAL-BENEFITS-ADDED'">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9">
                        <div style="margin-top:18px;" data-toggle="tooltip" data-placement="top" title="GigSumo">
                          <b>{{"GigSumo"}}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_PAGE_DEACTIVATED'">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null  || item['notifyData']['logo']==undefined"
                          class="img pic-size ntf-avatar-img-7463" src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate:22 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_PAGE_ACTIVATED'">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate:15 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'USER_LEFT_ORGANISATION'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.message }}">
                         <b>GigSumo</b></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'JOB_SOURCE_TRANSFER'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div *ngIf="item?.notifyData?.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.organisation }}">
                          {{ item?.notifyData?.organisation | truncate: 22 }}
                      </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'JOB_TARGET_TRANSFER'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_SOURCE_TRANSFER'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_TARGET_TRANSFER'">
              <div class="panel-body border-radius-top-left-right-6 pad-0"
                   [ngClass]="{'bg-pale': !item.read, 'bg-wt': item.read}">
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo'] == null"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             class="img pic-size ntf-avatar-img-7463"
                             src="assets/images/gallery/company.png"
                             alt="">
                        <img *ngIf="item['notifyData']['logo'] != null"
                             class="img pic-size ntf-avatar-img-7463"
                             src="{{item['notifyData']['logo']}}"
                             alt=""
                             (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts"
                             data-toggle="tooltip"
                             data-placement="top"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             title="{{item['notifyData']['businessName']}}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps"
                             data-toggle="tooltip"
                             data-placement="top"
                             *ngIf="item['notifyData']['title'] != null"
                             title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}
                        </div>
                        <div *ngIf="item.notifyData.organisation"
                             class="letter-gaps break-word"
                             data-toggle="tooltip"
                             data-placement="top"
                             title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_SOURCE_TRANSFER'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

             <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_JOB_TARGET_RECEIVE'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>



            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_CANDIDATE_TARGET_RECEIVE'">
              <div class="panel-body border-radius-top-left-right-6 pad-0"
                   [ngClass]="{'bg-pale': !item.read, 'bg-wt': item.read}">
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo'] == null"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             class="img pic-size ntf-avatar-img-7463"
                             src="assets/images/gallery/company.png"
                             alt="">
                        <img *ngIf="item['notifyData']['logo'] != null"
                             class="img pic-size ntf-avatar-img-7463"
                             src="{{item['notifyData']['logo']}}"
                             alt=""
                             (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts"
                             data-toggle="tooltip"
                             data-placement="top"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             title="{{item['notifyData']['businessName']}}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps"
                             data-toggle="tooltip"
                             data-placement="top"
                             *ngIf="item['notifyData']['title'] != null"
                             title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}
                        </div>
                        <div *ngIf="item.notifyData.organisation"
                             class="letter-gaps break-word"
                             data-toggle="tooltip"
                             data-placement="top"
                             title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_ACCESS_REVOKED_WORKSPACE_TARGET_RECEIVE'">
              <div class="panel-body border-radius-top-left-right-6 pad-0"
                   [ngClass]="{'bg-pale': !item.read, 'bg-wt': item.read}">
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo'] == null"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             class="img pic-size ntf-avatar-img-7463"
                             src="assets/images/gallery/company.png"
                             alt="">
                        <img *ngIf="item['notifyData']['logo'] != null"
                             class="img pic-size ntf-avatar-img-7463"
                             src="{{item['notifyData']['logo']}}"
                             alt=""
                             (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts"
                             data-toggle="tooltip"
                             data-placement="top"
                             (click)="routeToPageOrProfile(item, 'businessPage')"
                             title="{{item['notifyData']['businessName']}}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps"
                             data-toggle="tooltip"
                             data-placement="top"
                             *ngIf="item['notifyData']['title'] != null"
                             title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}
                        </div>
                        <div *ngIf="item.notifyData.organisation"
                             class="letter-gaps break-word"
                             data-toggle="tooltip"
                             data-placement="top"
                             title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED'">
              <div class="ntf-card-body-3916" [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.message }}">
                          <b>GigSumo</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_REVOKE'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="!(item['notifyData']['logo'] || item['notifyData']['businessLogo'])"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo'] || item['notifyData']['businessLogo']" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo'] || item['notifyData']['businessLogo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 22}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['businessName']}}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'PLAN_SUBSCRIPTION_IMPACTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                          <div class="col-md-3">
                            <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                          </div>
                          <div class="col-md-9 no-pad-rt">
                            <div class="letter-gaps solo-text break-word" data-toggle="tooltip" data-placement="top"
                              title="{{item.message }}">
                             <b>GigSumo</b></div>
                          </div>
                      <div class="col-md-9 no-pad-rt">
                        <div style="margin-top:15px;" class="letter-gaps break-word hov-txt" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] }}
                          {{item['notifyData']['lastName'] }}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 22}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_ADDED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate : 22}}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_ADDED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'POST_LIKED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div (click)="routeToPageOrProfile(item, 'profile')" *ngIf="!item?.notifyData?.logo"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item?.notifyData?.firstName, item?.notifyData?.lastName)">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item?.notifyData?.firstName,
                            item?.notifyData?.lastName)
                            }}
                          </div>
                        </div>
                        <img *ngIf="item?.notifyData?.logo" class="img pic-size ntf-avatar-img-7463" [src]="item?.notifyData?.logo" alt=""
                          (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div  (click)="routeToPageOrProfile(item, 'profile')" class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{ item?.notifyData?.firstName }} {{ item?.notifyData?.lastName }}">
                          {{ item?.notifyData?.firstName  + ' ' + item?.notifyData?.lastName | truncate: 22 }}
                        </div>
                        <div class="letter-gaps" *ngIf="item?.notifyData?.title" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.title }}">
                          {{ item?.notifyData?.title | truncate : 22 }}
                        </div>
                        <div *ngIf="item?.notifyData?.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.organisation }}">
                          {{ item?.notifyData?.organisation | truncate: 22 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{ item.notifyTime }}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'POST_COMMENTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="!item?.notifyData?.logo" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item?.notifyData?.firstName, item?.notifyData?.lastName)">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item?.notifyData?.firstName,
                            item?.notifyData?.lastName)
                            }}
                          </div>
                        </div>
                        <img *ngIf="item?.notifyData?.logo" class="img pic-size ntf-avatar-img-7463" [src]="item?.notifyData?.logo" alt=""
                          (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div (click)="routeToPageOrProfile(item, 'profile')" class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{ item?.notifyData?.firstName }} {{ item?.notifyData?.lastName }}">
                          {{ item?.notifyData?.firstName + ' ' + item?.notifyData?.lastName | truncate : 22 }}
                        </div>
                        <div *ngIf="item?.notifyData?.title" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.title }}">
                          {{ item?.notifyData?.title | truncate : 22 }}
                        </div>
                        <div *ngIf="item?.notifyData?.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item?.notifyData?.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.organisation }}">
                          {{ item?.notifyData?.organisation | truncate: 22 }}
                        </div>
                        <div *ngIf="item?.notifyData?.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{ item?.notifyData?.school }}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{ item?.notifyData?.school | truncate: 22 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{ item.notifyTime }}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'POST_SHARED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div (click)="routeToPageOrProfile(item, 'profile')" class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate : 22 }} </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 22 }}</div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate: 22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'REMOVED_FROM_MSG_GRP'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" class="img pic-size ntf-avatar-img-7463" src="assets/icon/message.jpg"
                          alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['messageGroup'] }}">
                          {{item['notifyData']['messageGroupName'] | truncate : 22 }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'LEFT_FROM_MSG_GRP'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 22 }}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate: 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'ADDED_TO_MSG_GRP'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'messageGroup')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/message.jpg" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'messageGroup')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'messageGroup')"
                          title="{{item['notifyData']['messageGroup'] }}">
                          {{item['notifyData']['messageGroupName'] | truncate : 15}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463" src="assets/icon/comm.png"
                          alt="" (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectCommunityInvitation(item, i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CUSTOMIZED_PLAN_REQUEST_UPDATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="" />
                      </div>
                      <div class="col-md-9">
                        <div style="margin-top: 18px;" data-toggle="tooltip" data-placement="top" title="GigSumo">
                          <b>{{ "GigSumo" }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_PAGE_DEACTIVATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" class="img pic-size ntf-avatar-img-7463" src="assets/icon/comm.png"
                          alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_PAGE_ACTIVATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row" *ngIf="!item.read">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate:22 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row" *ngIf="!item.read">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_USER_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_USER_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <!-- <img *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                                        class="img pic-size ntf-avatar-img-7463" src="assets/images/userAvatar.png" alt=""> -->
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}

                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_USER_INVITE_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_FOLLOWER_INVITE_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                        </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title'] != null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'COMMUNITY_MEMBER_JOINED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'communityPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/comm.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'communityPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'communityPage')"
                          title="{{item['notifyData']['communityName'] }}">
                          <span class="break-word">{{item['notifyData']['communityName'] | truncate: 22}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectCommunityInvitation(item, i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div *ngIf="item['notifyType'] === 'COMMUNITY_USER_JOINED'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/Sumoface_final.png" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div style="margin-top:18px;" data-toggle="tooltip" data-placement="top" title="GigSumo"
                          (click)="routeToPageOrProfile(item, 'profile')">
                          <b>{{"GigSumo"}}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'COMMUNITY_USER_JOIN_REQUEST'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="img pic-size ntf-avatar-img-7463" src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps hov-txt break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName'] }}"
                          (click)="routeToPageOrProfile(item, 'profile')">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          *ngIf="item['notifyData']['title']!=null" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="addOrRejectMemberToCommunity(item, 'REJECT', i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>


            <div *ngIf="item['notifyType'] === 'CONNECT_REQUEST_RECEIVED'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="ntf-avatar-section-2951">
                      <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                        class="circles ntf-avatar-img-7463" style="cursor: pointer;"
                        [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                        <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                          item['notifyData']['lastName']) }}
                        </div>
                      </div>
                      <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                        src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      <div class="no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts ntf-sender-name-8294" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title=" {{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }}"
                          style="
                          max-width: 140px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: inline-block;"
                          >
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22}}
                        </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps ntf-sender-subtitle-3672" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps ntf-sender-subtitle-3672">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word ntf-sender-subtitle-3672" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}"
                          style="
                          max-width: 140px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: inline-block;"
                          >
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14 ntf-sender-subtitle-3672"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify ntf-message-section-5918">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3 ntf-actions-section-2847">
                    <div class="btn-group">
                      <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                        <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                      </div>
                      <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                        <button mat-menu-item (click)="rejectConnection(item, i)">Reject</button>
                        <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">
                    {{item.notifyTime}}
                  </span>
                </div>
              </div>

            </div>


            <div *ngIf="item['notifyType'] === 'CONNECTION_REMOVED'" class="hpnel">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                            {{ getInitials(item['notifyData']['firstName'], item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName']  + ' ' + item['notifyData']['lastName'] | truncate:22}}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div *ngIf="item['notifyType'] === 'JOINED_NETWORK'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                            {{ getInitials(item['notifyData']['firstName'], item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div *ngIf="item['notifyType'] === 'User_itself_remove_from_Network'" class="ntf-card-wrapper-8472">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'Network_Removed'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22}}
                          </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_DELETED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-share-400.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" style="cursor: auto !important;"
                          class="img pic-size ntf-avatar-img-7463" src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.networkName }}">
                          {{item.notifyData.networkName | truncate: 22}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_ACTIVATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-share-400.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" style="cursor: auto !important;"
                          class="img pic-size ntf-avatar-img-7463" src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.networkName }}">
                          {{item.notifyData.networkName | truncate: 22}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_INVITE_SENT'">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22}}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectNetworkMemberInvitation(item, i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_INVITE_CANCELLED'">

              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <img *ngIf="item['notifyData']['logo']==null" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/icons8-share-400.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['networkPage'] }}">
                          {{item['notifyData']['networkName'] | truncate : 22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_CONNECT_REQUEST_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22}}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'NETWORK_CONNECT_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']  }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'JOINED_TEAM'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectTeamInvitation(item, i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === GigsumoConstant.LEFT_TEAM">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22}}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === GigsumoConstant.TEAM_DEACTIVATED">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word solo-text hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>

                      </div>

                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472"
            *ngIf="[GigsumoConstant.TEAM_INACTIVE, GigsumoConstant.LEFT_TEAM_BY_ORG_CHANGE, GigsumoConstant.SUPERADMIN_INACTIVE].includes(item['notifyType'])"
            >
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" style="cursor: auto !important;"
                          class="img pic-size ntf-avatar-img-7463" src="assets/icon/icons8-people-100.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-people-100.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.teamName }}">
                          {{item.notifyData.teamName | truncate: 22}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAM_ACTIVATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" style="cursor: auto !important;"
                          class="img pic-size ntf-avatar-img-7463" src="assets/icon/icons8-people-100.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-people-100.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.teamName }}">
                          {{item.notifyData.teamName | truncate: 22}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAM_OWNER_UPDATE'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-people-100.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.teamName }}">
                          {{item.notifyData.teamName | truncate: 22}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAM_INVITE_CANCELLED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" style="cursor: auto !important;"
                          class="img pic-size ntf-avatar-img-7463" src="assets/icon/icons8-people-100.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          style="cursor: auto !important;" src="assets/icon/icons8-people-100.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.notifyData.teamName }}">
                          {{item.notifyData.teamName | truncate: 30}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAMS_REMOVED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CONNECT_REQUEST_CANCELLED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                            {{ getInitials(item['notifyData']['firstName'], item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAM_CONNECT_REQUEST_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="assets/icon/icons8-people-100.png" alt=""
                          (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'DOMAIN_BUSINESS_UPDATE'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.message }}">
                          <b>GigSumo</b></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'UPDATED_TO_BUSINESS_PLAN'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item.message }}">
                         <b>GigSumo</b></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read || isSuperAdmin">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item *ngIf="isSuperAdmin" (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_SENT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'businessPage')" data-placement="top"
                          title="{{item.notifyData.businessName }}">
                          {{item.notifyData.businessName | truncate: 15}}</div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'TEAM_CONNECT_REQUEST_CANCELLED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles" style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                            {{ getInitials(item['notifyData']['firstName'], item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName'] }} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate:22 }}
                          </div>
                        <div class="letter-gaps" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12" *ngIf="!item.read">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_EMPLOYEE_INVITE_REQUEST'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps hov-txt break-word name-fonts" data-toggle="tooltip"
                          (click)="routeToPageOrProfile(item, 'profile')" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName'] }}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div *ngIf="item['notifyData']['title'] !== null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation; else businessNameTemplate"
                          class="letter-gaps break-word" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <ng-template #businessNameTemplate class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top">
                          {{item['notifyData']['businessName'] | truncate : 22}}
                        </ng-template>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectBusinessEmployee(item, i)">Deny</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'BUSINESS_PAGE_FOLLOWER_INVITE_SENT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'businessPage')" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gallery/company.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'businessPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps solo-text break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          (click)="routeToPageOrProfile(item, 'businessPage')"
                          title="{{item['notifyData']['businessName'] }}">
                          {{item['notifyData']['businessName'] | truncate:15 }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">

                            <button mat-menu-item (click)="rejectBusinessFollowerRequest(item, i)">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_INVITATION_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'candidatesInvitedPage')" class="circles "
                          style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'candidatesInvitedPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_INVITATION_ACCEPTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          (click)="routeToPageOrProfile(item, 'candidatesInvitedPage')" class="circles "
                          style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt=""
                          (click)="routeToPageOrProfile(item, 'candidatesInvitedPage')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item['notifyData']['userType'] == 'JOB_SEEKER'" class="letter-gaps break-word"
                          data-toggle="tooltip" data-placement="top"
                          [title]="formatUserType(item['notifyData']['userType'])">
                          {{ formatUserType(item['notifyData']['userType']) | titlecase }}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_ONBOARDED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_REJECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_PREONBOARDED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'JOB-OFFERED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] ==='OFFER-WITHDRAWN'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] ==='CANDIDATE BACKOUT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                            <button mat-menu-item (click)="redirectToSaidPage(item)">View</button>
                          </mat-menu>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE-SHORTLISTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'INTERVIEW-SCHEDULED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CANDIDATE_GOT_SELECTED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'JOB_STATUS_CHANGED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>

                        <div *ngIf="item?.notifyData?.jobData?.jobPostedBehalfOf && item?.notifyData?.jobData?.jobPostedBehalfOf !== 'null'" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{ item?.notifyData?.jobData?.jobPostedBehalfOf }}">

                          {{ item?.notifyData?.jobData?.jobPostedBehalfOf | truncate:22 }}

                        </div>

                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div>
                        </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>

                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <div class="ntf-card-wrapper-8472"
              *ngIf="item['notifyType'] === 'RESUME_REQUEST_ACCEPTED' || item['notifyType'] === 'RESUME_UPDATED' ">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                        <div *ngIf="item['notifyData']['userType'] == 'JOB_SEEKER'" class="letter-gaps break-word"
                          data-toggle="tooltip" data-placement="top"
                          [title]="formatUserType(item['notifyData']['userType'])">
                          {{ formatUserType(item['notifyData']['userType']) | titlecase}}
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <!-- Resume requested — notify the candidate owner that a recruiter
                 requested this candidate's resume. Mirrors the RESUME_REQUEST_ACCEPTED
                 card; notifyData.firstName/lastName = the requester, candidateData =
                 the candidate, jobTitle/jobId = the job the resume was requested for. -->
            <div class="ntf-card-wrapper-8472"
              *ngIf="item['notifyType'] === 'RESUME_REQUEST_INITIATED'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['firstName'], item['notifyData']['lastName'])">{{ getInitials(item['notifyData']['firstName'],
                            item['notifyData']['lastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="" (click)="routeToPageOrProfile(item, 'profile')">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word name-fonts" data-toggle="tooltip" data-placement="top"
                          title="{{item['notifyData']['firstName']}} {{item['notifyData']['lastName']}}">
                          {{item['notifyData']['firstName'] + ' ' + item['notifyData']['lastName'] | truncate: 22 }}
                          </div>
                        <div class="letter-gaps" *ngIf="item['notifyData']['title']!=null" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri}}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>

                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3 ntf-actions-section-2847">
                    <div class="btn-group">
                      <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                        <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                      </div>
                      <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                        <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>


            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'CREDITS_CONSUMPTION_ALERT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9">
                        <div style="margin-top:18px;" data-toggle="tooltip" data-placement="top" title="GigSumo">
                          <b>{{"GigSumo"}}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <!-- 2st part -->

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'INSUFFICIENT_CREDITS_ALERT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img *ngIf="item['notifyData']['logo']==null" (click)="routeToPageOrProfile(item, 'profile')"
                          class="img pic-size ntf-avatar-img-7463" src="assets/images/userAvatar.png" alt="">
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="assets/images/gigsumo-admin.jpg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>

            <!-- candidate document notifications -->

            <div *ngIf="item['notifyType'] === 'JOB_OWNER_REQUEST'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">{{ getInitials(item['notifyData']['jobOwnerFirstName'],
                            item['notifyData']['jobOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <!-- (click)="routeToPageOrProfile(item, 'profile')" -->
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['jobOwnerFirstName'] }} {{item['notifyData']['jobOwnerLastName'] }}">
                          {{item['notifyData']['jobOwnerFirstName'] + ' ' + item['notifyData']['jobOwnerLastName'] | truncate:22}}
                        </div>
                        <!-- <div *ngIf="item['notifyData']['title']!=null" class="letter-gaps" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['title'] | decodeUri }}">
                          {{item['notifyData']['title'] | decodeUri | truncate : 20}}</div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps">
                          Student
                        </div>
                        <div *ngIf="item.notifyData.organisation" class="letter-gaps break-word" data-toggle="tooltip"
                          data-placement="top" title="{{item['notifyData']['organisation']}}">
                          {{item['notifyData']['organisation'] | truncate : 22}}
                        </div>
                        <div *ngIf="item.notifyData.school" class="letter-gaps break-word mr-lf-14"
                          data-toggle="tooltip" data-placement="top" title="{{item['notifyData']['school']}}">
                          <span><ng-icon name="tablerSchool"></ng-icon></span>
                          {{item['notifyData']['school'] | truncate:22}}
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'JOB_OWNER_ADDITIONAL_REQUEST'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">{{ getInitials(item['notifyData']['jobOwnerFirstName'],
                            item['notifyData']['jobOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['jobOwnerFirstName'] }} {{item['notifyData']['jobOwnerLastName'] }}">
                          {{item['notifyData']['jobOwnerFirstName'] + ' ' + item['notifyData']['jobOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_REJECTION'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">

                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">{{ getInitials(item['notifyData']['jobOwnerFirstName'],
                            item['notifyData']['jobOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <!-- (click)="routeToPageOrProfile(item, 'profile')" -->
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['jobOwnerFirstName'] }} {{item['notifyData']['jobOwnerLastName'] }}">
                          {{item['notifyData']['jobOwnerFirstName'] + ' ' + item['notifyData']['jobOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_EXPIRED'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">{{ getInitials(item['notifyData']['jobOwnerFirstName'],
                            item['notifyData']['jobOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['jobOwnerFirstName'] }} {{item['notifyData']['jobOwnerLastName'] }}">
                          {{item['notifyData']['jobOwnerFirstName'] + ' ' + item['notifyData']['jobOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_OWNER_SUBMISSION'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">{{ getInitials(item['notifyData']['CandidateOwnerFirstName'],
                            item['notifyData']['CandidateOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['CandidateOwnerFirstName'] }} {{item['notifyData']['CandidateOwnerLastName'] }}">
                          {{item['notifyData']['CandidateOwnerFirstName'] + ' ' + item['notifyData']['CandidateOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_REUPLOAD'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">{{ getInitials(item['notifyData']['CandidateOwnerFirstName'],
                            item['notifyData']['CandidateOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['CandidateOwnerFirstName'] }} {{item['notifyData']['CandidateOwnerLastName'] }}">
                          {{item['notifyData']['CandidateOwnerFirstName'] + ' ' + item['notifyData']['CandidateOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_EXPIRED_DOCUMENT_REUPLOAD'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['CandidateOwnerFirstName'], item['notifyData']['CandidateOwnerLastName'])">{{ getInitials(item['notifyData']['CandidateOwnerFirstName'],
                            item['notifyData']['CandidateOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['CandidateOwnerFirstName'] }} {{item['notifyData']['CandidateOwnerLastName'] }}">
                          {{item['notifyData']['CandidateOwnerFirstName'] + ' ' + item['notifyData']['CandidateOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="item['notifyType'] === 'CANDIDATE_DOCUMENT_ALL_VERIFIED'" class="ntf-card-wrapper-8472">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <div *ngIf="item['notifyData']['logo']==null"
                          class="circles " style="cursor: pointer;"
                          [style.background-color]="getColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">
                          <div class="circle-text" [style.color]="getTextColor(item['notifyData']['jobOwnerFirstName'], item['notifyData']['jobOwnerLastName'])">{{ getInitials(item['notifyData']['jobOwnerFirstName'],
                            item['notifyData']['jobOwnerLastName']) }}
                          </div>
                        </div>
                        <img *ngIf="item['notifyData']['logo']!=null" class="img pic-size ntf-avatar-img-7463"
                          src="{{item['notifyData']['logo']}}" alt="">
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div class="letter-gaps break-word hov-txt name-fonts" data-toggle="tooltip" data-placement="top"
                          title=" {{item['notifyData']['jobOwnerFirstName'] }} {{item['notifyData']['jobOwnerLastName'] }}">
                          {{item['notifyData']['jobOwnerFirstName'] + ' ' + item['notifyData']['jobOwnerLastName'] | truncate:22}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>

                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>
              </div>
            </div>

            <div class="ntf-card-wrapper-8472" *ngIf="item['notifyType'] === 'ADMIN_ACTION_BY_REPORT'">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="">
                      </div>
                      <div class="col-md-9">
                        <div style="margin-top:18px;" data-toggle="tooltip" data-placement="top" title="GigSumo">
                          <b>{{"GigSumo"}}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item (click)="markAsRead(item, i)">Mark As Read</button>

                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{item.notifyTime}}</span>
                </div>

              </div>

            </div>
            <!-- businessenterpriseplan -->
            <div class="ntf-card-wrapper-8472"
              *ngIf="['BUSINESS_PAGE_CONTACT_INVITE', 'BUSINESS_COLLABRATION_INVITE','BUSINESS_COLLABRATION_INVITE_ACCEPTED','BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'].includes(item['notifyType'])">
              <div class="ntf-card-body-3916"
                [ngClass]="{'bg-pale ntf-unread-bg-7284': !item?.read, 'bg-wt ntf-read-bg-4127': item?.read}">
                <span class="ntf-unread-dot-5639" *ngIf="!item?.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col-md-3">
                        <!-- Profile Picture or Initials -->
                        <!-- <div
                          *ngIf="(!item?.notifyData?.photo && (item['notifyType'] === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'))"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          class="circles"
                          style="cursor: pointer;"
                          [style.background-color]="getColor(item?.notifyData?.firstName, item?.notifyData?.lastName)">
                          <div class="circle-text">
                            {{ getInitials(item?.notifyData?.firstName, item?.notifyData?.lastName) }}
                          </div>
                        </div> -->

                        <!-- Profile Photo -->
                        <!-- <img
                          *ngIf="(item?.notifyData?.photo && (item['notifyType'] === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'))"
                          (click)="routeToPageOrProfile(item, 'profile')"
                          class="img pic-size ntf-avatar-img-7463"
                          [src]="url + item?.notifyData?.photo"
                          alt=""> -->
                          <ng-container *ngIf="item['notifyType'] === 'BUSINESS_COLLABRATION_INVITE_ACCEPTED' || item['notifyType'] === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'; else businessLogo">
                            <img
                              class="img pic-size ntf-avatar-img-7463"
                              src="assets/icon/Sumoface_final.png"
                              alt="">
                          </ng-container>

                          <ng-template #businessLogo>
                            <img
                              *ngIf="item?.notifyData?.logo"
                              class="img pic-size ntf-avatar-img-7463"
                              [src]="item?.notifyData?.logo"
                              alt=""
                              (click)="routeToPageOrProfile(item, 'businessPage')">
                            <img
                              *ngIf="!item?.notifyData?.logo"
                              class="img pic-size ntf-avatar-img-7463"
                              src="assets/images/gallery/company.png"
                              alt=""
                              (click)="routeToPageOrProfile(item, 'businessPage')">
                          </ng-template>
                      </div>
                      <div class="col-md-9 no-pad-rt">
                        <div  style="margin-top:16px;"*ngIf="item['notifyType'] === 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED' || item['notifyType'] === 'BUSINESS_COLLABRATION_INVITE_ACCEPTED'; else businessInfo">
                          <span><b>GigSumo</b></span>
                        </div>
                        <ng-template #businessInfo>
                          <div
                          class="letter-gaps break-word solo-text hov-txt"
                          data-toggle="tooltip"
                          data-placement="top"
                          (click)="routeToPageOrProfile(item, getProfileType(item))"
                          [title]="getTooltipTitle(item)">
                            <div>
                              <span>{{ item?.notifyData?.businessName | truncate:22 }}</span>
                            </div>
                            <div>
                              <span>{{ item?.notifyData?.organisation | truncate:22 }}</span>
                            </div>
                        </div>
                        </ng-template>
                      </div>

                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="btn-group" *ngIf="!['BUSINESS_COLLABRATION_INVITE_ACCEPTED', 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'].includes(item['notifyType']) || !item.read">
                          <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                            <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821">
                          </div>
                          <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                            <button mat-menu-item *ngIf="!['BUSINESS_COLLABRATION_INVITE_ACCEPTED', 'BUSINESS_PAGE_CONTACT_INVITE_ACCEPTED'].includes(item['notifyType'])" (click)="handleContactInvite(item, i,'REJECT')">Reject</button>
                            <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">{{ item?.notifyTime }}</span>
                </div>
              </div>
            </div>
            <!-- newdesign -->
            <div class="ntf-card-wrapper-8472" *ngIf="isSupportedNotifyType(item['notifyType'])">
              <div class="ntf-card-body-3916"
                [ngClass]="{ 'bg-pale ntf-unread-bg-7284': !item.read, 'bg-wt ntf-read-bg-4127': item.read }">
                <span class="ntf-unread-dot-5639" *ngIf="!item.read"></span>
                <div class="row contain ntf-content-wrap-6843">
                  <div class="col-md-4">
                    <div class="ntf-avatar-section-2951">
                      <!-- Business logo for CONTRACT_AGREEMENT_DOCUMENT_UPLOADED -->
                      <ng-container *ngIf="item['notifyType'] === 'CONTRACT_AGREEMENT_DOCUMENT_UPLOADED' || item['notifyType'] === 'CONTRACT_COMPANY_DOC_CHECKLIST_CREATED' || item['notifyType'] === 'CONTRACT_COMPANY_DOC_UPLOADED' || item['notifyType'] === 'CONTRACT_COMPANY_DOC_VERIFIED' || item['notifyType'] === 'CONTRACT_COMPANY_DOC_REJECTED' || item['notifyType'] === 'CONTRACT_AGREEMENT_SIGNING_REQUESTED' || item['notifyType'] === 'CONTRACT_AGREEMENT_SIGNED' || item['notifyType'] === 'CONTRACT_AGREEMENT_ACCEPTED' || item['notifyType'] === 'CONTRACT_AGREEMENT_REJECTED' || item['notifyType'] === 'CONTRACT_WORK_ORDER_INITIATED' || item['notifyType'] === 'CONTRACT_WORK_ORDER_ACCEPTED' || item['notifyType'] === 'CONTRACT_WORK_ORDER_REJECTED' || item['notifyType'] === 'CONTRACT_WORK_ORDER_REVISED' || item['notifyType'] === 'CONTRACT_WORK_ORDER_VOIDED' || item['notifyType'] === 'CONTRACT_INITIATED' || item['notifyType'] === 'CONTRACT_INVOICE_SUBMITTED' || item['notifyType'] === 'CONTRACT_INVOICE_APPROVED' || item['notifyType'] === 'CONTRACT_INVOICE_REJECTED' || item['notifyType'] === 'CONTRACT_INVOICE_PAID' || item['notifyType'] === 'CONTRACT_PAYMENT_RECEIVED' || item['notifyType'] === 'CONTRACT_INVOICE_VOIDED'; else defaultSumoAvatar">
                        <img *ngIf="item['notifyData']?.['businessLogo'] || item['notifyData']?.['logo']" class="img pic-size ntf-avatar-img-7463" src="{{item['notifyData']['businessLogo'] || item['notifyData']['logo']}}" alt="" />
                        <img *ngIf="!item['notifyData']?.['businessLogo'] && !item['notifyData']?.['logo']" class="img pic-size ntf-avatar-img-7463" src="assets/images/gallery/company.png" alt="" />
                        <div class="ntf-sender-name-8294" data-toggle="tooltip" data-placement="top" title="{{item['notifyData']?.['businessName']}}">
                          {{ item['notifyData']?.['businessName'] }}
                        </div>
                      </ng-container>
                      <ng-template #defaultSumoAvatar>
                        <img class="img pic-size ntf-avatar-img-7463" src="assets/icon/Sumoface_final.png" alt="" />
                        <div class="ntf-sender-name-8294" data-toggle="tooltip" data-placement="top" title="GigSumo">
                          {{ "GigSumo" }}
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div class="col-md-5 xr text-justify ntf-message-section-5918">
                    <app-notification-message [item]="item" [showActions]="true" (action)="onMessageAction($event, item, i)" (celebrate)="celebrate()"></app-notification-message>
                  </div>
                  <div class="col-md-3 ntf-actions-section-2847">
                    <!-- Plan renewal (STRIPE_INVOICE_SUCCESS): View is Business Super Admin only,
                         so the menu shows for others only while Mark As Read is available. -->
                    <div class="btn-group" *ngIf="(['STRIPE_PAYMENT_TRANSACTION_FAILURE', 'STRIPE_INVOICE_FAILURE', 'MEMBERSHIP_UPDATED', 'STRIPE_INVOICE_SUCCESS', 'CONTRACT_AGREEMENT_DOCUMENT_UPLOADED', 'CONTRACT_COMPANY_DOC_CHECKLIST_CREATED', 'CONTRACT_COMPANY_DOC_UPLOADED', 'CONTRACT_COMPANY_DOC_VERIFIED', 'CONTRACT_COMPANY_DOC_REJECTED', 'CONTRACT_AGREEMENT_SIGNING_REQUESTED', 'CONTRACT_AGREEMENT_SIGNED', 'CONTRACT_AGREEMENT_ACCEPTED', 'CONTRACT_AGREEMENT_REJECTED', 'CONTRACT_WORK_ORDER_INITIATED', 'CONTRACT_WORK_ORDER_ACCEPTED', 'CONTRACT_WORK_ORDER_REJECTED', 'CONTRACT_WORK_ORDER_REVISED', 'CONTRACT_WORK_ORDER_VOIDED', 'CONTRACT_INITIATED', 'CONTRACT_INVOICE_SUBMITTED', 'CONTRACT_INVOICE_APPROVED', 'CONTRACT_INVOICE_REJECTED', 'CONTRACT_INVOICE_PAID', 'CONTRACT_PAYMENT_RECEIVED', 'CONTRACT_INVOICE_VOIDED'].includes(item.notifyType) && (item.notifyType !== 'STRIPE_INVOICE_SUCCESS' || isSuperAdmin)) || !item.read">
                      <div class="ntf-menu-trigger-6193" [matMenuTriggerFor]="notifyMenu">
                        <img src="assets/icon/icons8-more-96.png" alt="" class="ntf-three-dot-img-4821" />
                      </div>
                      <mat-menu #notifyMenu="matMenu" panelClass="ntf-mat-menu-panel-7293">
                        <button mat-menu-item *ngIf="!item.read" (click)="markAsRead(item, i)">Mark As Read</button>
                        <button mat-menu-item *ngIf="['STRIPE_PAYMENT_TRANSACTION_FAILURE', 'STRIPE_INVOICE_FAILURE', 'MEMBERSHIP_UPDATED','STRIPE_INVOICE_SUCCESS', 'CONTRACT_AGREEMENT_DOCUMENT_UPLOADED', 'CONTRACT_COMPANY_DOC_CHECKLIST_CREATED', 'CONTRACT_WORK_ORDER_INITIATED', 'CONTRACT_WORK_ORDER_ACCEPTED', 'CONTRACT_WORK_ORDER_REJECTED', 'CONTRACT_WORK_ORDER_REVISED', 'CONTRACT_WORK_ORDER_VOIDED', 'CONTRACT_INITIATED', 'CONTRACT_INVOICE_SUBMITTED', 'CONTRACT_INVOICE_APPROVED', 'CONTRACT_INVOICE_REJECTED', 'CONTRACT_INVOICE_PAID', 'CONTRACT_PAYMENT_RECEIVED', 'CONTRACT_INVOICE_VOIDED'].includes(item.notifyType) && (item.notifyType !== 'STRIPE_INVOICE_SUCCESS' || isSuperAdmin)" (click)="redirectToSaidPage(item)">View</button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <div class="ntf-timestamp-row-4582">
                  <span class="ntf-timestamp-text-7391">
                    {{ item.notifyTime }}
                  </span>
                </div>
              </div>
            </div>


          </ng-container>
          <app-common-skeleton *ngIf="(isEnabled && commonVariables?.notifications?.length > 0)" [countforView]="3"
            [NameOftheScreen]="'notification'"></app-common-skeleton>

        </div>
        <div *ngIf="bottomFlag&&commonVariables?.notifications?.length > 0" class="row caught_up_notification ntf-bottom-reached-7348">
          <div class="col-md-12 mg-bt-9">
                    <ng-icon name="tablerCircleCheck"></ng-icon>
          </div>
          <div class="col-md-12">
            <p class="font-16 ntf-empty-title-7162">You've reached the bottom of the page</p>
          </div>
          <div class="col-md-12">
            <p class="biase ntf-empty-desc-3945">Those are the notifications you've received so far.</p>
          </div>
        </div>
      </div>


      <div *ngIf="!notificationSettings" class="col-md-3 stick-there1" style="padding-left: 0px;">
        <app-common-widget [page]="'MESSAGE_PAGE'" [inputData]="'NOTIFICATIONS'"></app-common-widget>

      </div>

      <div *ngIf="notificationSettings" class="col-md-10">
        <app-notification-config></app-notification-config>
      </div>


    </div>
  </div>

  <app-common-modal *ngIf="showModal" [businessDetails]="businessDetails"
   [b2bnetworkcarddata]="{ email: selectedBusinessEmail, id: ownerbusinessId}" [ownerid]="myResolvedBusinessId" [title]="selectedItem" [type]="'ADD'" (response)="closeModal($event)"></app-common-modal>
